<template>
    <dashboard>
        <row>
            <panel>
                <h2 slot="title">Imports</h2>
                <template slot="buttons">
                    <app-button size="small" @click="newImport">New Import</app-button>
                </template>

                <el-table
                    :data="imports"
                    style="width: 100%"
                    empty-text="No Imports Yet"
                    @current-change="navigateToImportDetail">
                    <el-table-column prop="created_at" label="Date">
                        <template slot-scope="scope">
                            <router-link
                                :aria-label="'Import At: '+ scope.row.created_at"
                                :to="{ name: 'imports.detail', params: { uuid: scope.row.uuid } }">{{ scope.row.created_at | moment("MM/DD/YYYY hh:mma") }}</router-link>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" label="Status">
                        <template slot-scope="scope">{{ statusText(scope.row.status) }}</template>
                    </el-table-column>
                    <el-table-column prop="progress" label="Progress">
                        <template slot-scope="scope">
                            <template v-if="scope.row.progress">{{ scope.row.progress }}%</template>
                            <template v-else>None</template>
                        </template>
                    </el-table-column>
                </el-table>
            </panel>
        </row>
    </dashboard>
</template>

<script>
import Import from '@/store/models/Import'

export default {
    name: 'page-imports',
    props: {
        query: String
    },
    head: {
        title: {
            inner: 'Imports'
        }
    },
    computed: {
        imports() { return Import.query().orderBy('created_at', 'desc').get() }
    },
    created() {
        Import.$fetchAll()
    },
    methods: {
        navigateToImportDetail(location) {
            this.$router.push({
                name: 'imports.detail',
                params: { uuid: location.uuid }
            })
        },
        newImport() {
            this.$router.push({
                name: 'imports.detail',
                params: { uuid: 'New' }
            })
        },
        statusText(status) {
            switch (status) {
            case 1:
                return 'Created'
            case 2:
                return 'Pending'
            case 3:
                return 'Processing'
            case 4:
                return 'Finished'
            }
        }
    }
}
</script>

<style lang="stylus"></style>
